import axios from 'axios';

import {
  getHeaders,
} from './Utils';

import {
  ENDPOINT_FILEREAD_COVER,
} from './constants';

export default class Cover {
  static getCoverFile(filepath) {
    return axios({
      method: 'post',
      headers: getHeaders(),
      url: ENDPOINT_FILEREAD_COVER,
      data: {
        coverfile: filepath,
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/api/Cover.js